export default __webpack_public_path__ + "static/media/ChosenBg.33e5b0c7.png";